import ButtonV2 from "@/components/shared/buttonV2";
import Modal from "@/components/shared/modal";

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const OwnerPdfInfoModal: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal
      show={isOpen}
      showClose={true}
      title="PDF機能のご利用について"
      setShow={setIsOpen}
    >
      <div className="p-24 pt-0 text-md">
        <div className="">
          <p>
            PDF報告書のダウンロードは、有料オプションで可能です。詳細や申込については以下の「詳細を見る」ボタンからご確認ください。
          </p>
          <div className="mt-24 space-y-8">
            <ButtonV2
              variant="primary"
              layout="fullWidth"
              click={() => {
                window.open(
                  "https://galvanized-jewel-836.notion.site/_-PDF-978ef9cdbfdb4daf9a886635aae0d60a?pvs=4",
                  "_blank"
                );
                setIsOpen(false);
              }}
            >
              詳細を見る
            </ButtonV2>
            <ButtonV2
              variant="primaryOutline"
              layout="fullWidth"
              click={() => setIsOpen(false)}
            >
              閉じる
            </ButtonV2>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OwnerPdfInfoModal;
